export default __webpack_public_path__ + "static/media/images/jonas.e313804b.png";